var exports = {
  "vK": "PremiumUpsellBanner.module__banner___NW01VW",
  "Qs": "PremiumUpsellBanner.module__content___NW01VW",
  "Qq": "PremiumUpsellBanner.module__text___NW01VW",
  "Wz": "PremiumUpsellBanner.module__communityRow___NW01VW",
  "ju": "PremiumUpsellBanner.module__communityIcon___NW01VW",
  "nG": "PremiumUpsellBanner.module__communityMore___NW01VW",
  "rT": "PremiumUpsellBanner.module__previewRow___NW01VW",
  "kH": "PremiumUpsellBanner.module__previewItem___NW01VW",
  "yY": "PremiumUpsellBanner.module__previewEmojiText___NW01VW",
};

module.exports = exports;
